import React from "react"
import { Link } from 'react-router-dom'
import "../App.css"
import "./Artwork.css"
import HeaderNav from "../misc/headerNav.jsx"
import ArtworkSide from "./ArtworkSide"
import deleteIcon from "../assets/delete.png"

export default class Artwork extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            artList: [],
            imageError: false,
        }
    }

    componentDidMount() {
        fetch(process.env.REACT_APP_API_PATH + "/file-uploads", {
            method: "GET",
            headers: {
                'Authorization': 'Bearer ' + sessionStorage.getItem("token")
            },
        })
            .then(res => {
                if (!res.ok) {
                    this.setState({
                        imageError: true
                    });
                    return;
                } else {
                    this.setState({
                        imageError: false
                    });
                }
                return res.json();
            })
            .then(
                result => {
                    this.setState({
                        artList: result[0].filter(art => (
                            art.attributes.postID === this.props.postID
                        ))
                    })
                    console.log(this.state.artList)
                }
            )
    }


    deleteArt(id) {
        fetch(process.env.REACT_APP_API_PATH + "/file-uploads/" + id, {
            method: "DELETE",
            headers: {
                'Authorization': 'Bearer ' + sessionStorage.getItem("token")
            }
        })
            .then(
                _ => {
                    window.location.reload()
                }
            )
    }


    showDelete(uploaderID, id) {
        if (uploaderID === sessionStorage.getItem("user")) {
            return (
                <img src={deleteIcon} className="deleteIconArt" alt="Delete Art" title="Delete Art" onClick={event => this.deleteArt(id)}></img>
            )
        }
    }


    render() {
        let renderArt
        if (this.state.artList.length != 0) {
            renderArt = this.state.artList.map(art => (
                <div>
                    <img className="artImg" alt='art for story' src={"https://webdev.cse.buffalo.edu" + art.path}></img>
                    {this.showDelete(art.uploaderID, art.id)}
                </div>
            ))
        }
        else {
            renderArt = <p style={{ fontSize: "16px", color: "grey" }}>The gallery is empty! Be the first to upload! :)</p>
        }

        return (
            <div className="artPage">
                <HeaderNav />
                <div className="artRow">
                    <div className="artLeft">
                        {this.state.imageError ? <div className="errormess">Upload error! image may be to large or small.</div> : ""}
                        <span className="artworkTitle">Artwork</span>
                        <div className="displayArt">{renderArt}</div>
                    </div>
                    <ArtworkSide postID={this.props.postID} />
                </div>
            </div>
        )
    }
}